<template>
    <div>
        <ConfirmPageBlock
            stepsLength="7"
            url="/statement-of-use/step-number"
        ></ConfirmPageBlock>
    </div>
</template>

<script>
import ConfirmPageBlock from '@/components/blocks/ConfirmPageBlock.vue'
import {to_top} from "@/helper";

export default {
    components: {
        ConfirmPageBlock
    },
    mounted() {
        to_top()
        this.$store.commit('header/setTotal', 0)
    }
}
</script>
